import format from 'format-number'

export default function(value) {
  const parsed = parseFloat(value) || 0

  return format({ prefix: '£', padRight: 2 })(parsed.toFixed(2))
}
